/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {createMockMatchList} from '~/pages/worldCup/pages/list/mock'
import {MOCK_MATCH_EVENTS} from '~/pages/worldCup/components/events/mock'
import {fetchMockMatchDetail} from '~/pages/worldCup/components/matchDetail/mock'
import {getMockLineup} from '~/pages/worldCup/components/lineUps/mock'

export const subscribe_world_cup_match = createAsyncThunk(
  'worldCup/subscribe_world_cup_match',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/subscribe_world_cup_match',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const bind_room_fto = createAsyncThunk(
  'worldCup/bind_room_fto',
  async (params: any, store: any) => {
    const {
      deviceinfo: {h_web_room_id},
    } = store.getState().env
    const resp = await http.post(
      '/live/room/bind_room_fto',
      {
        room_id: h_web_room_id,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const get_world_cup_match_list = createAsyncThunk(
  'worldCup/get_world_cup_match_list',
  async (params: any, store: any) => {
    const {
      deviceinfo: {h_web_room_id},
    } = store.getState().env
    // return createMockMatchList()
    const resp = await http.post(
      '/live/room/get_world_cup_match_list',
      {
        room_id: h_web_room_id,
        offset: 0,
        limit: 1000,
        page_size: 1000,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp?.data?.data?.list || []
  }
)

export const get_world_cup_match_events = createAsyncThunk(
  'worldCup/get_world_cup_match_events',
  async (params: any, store: any) => {
    // return MOCK_MATCH_EVENTS
    const resp = await http.post(
      '/live/room/get_world_cup_match_events',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.events || []
  }
)
export const get_world_cup_match_detail = createAsyncThunk(
  'worldCup/get_world_cup_match_detail',
  async (params: any, store: any) => {
    // return fetchMockMatchDetail().match
    const resp = await http.post(
      '/live/room/get_world_cup_match_detail',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.match || {}
  }
)
export const get_world_cup_match_stats = createAsyncThunk(
  'worldCup/get_world_cup_match_stats',
  async (params: any, store: any) => {
    // return {
    //   home_shots: 12,
    //   away_shots: 9,
    //   home_shots_on: 5,
    //   away_shots_on: 4,
    //   home_attacks: 58,
    //   away_attacks: 42,
    //   home_corners: 12,
    //   away_corners: 9,
    //   home_possession: 58,
    //   away_possession: 42,
    //   home_fouls: 12,
    //   away_fouls: 9,
    //   home_yellow: 12,
    //   away_yellow: 9,
    //   home_red: 0,
    //   away_red: 0,
    //   home_offsides: 12,
    //   away_offsides: 9,
    //   home_passes: 420,
    //   away_passes: 380,
    //   home_pass_accuracy: 88,
    //   away_pass_accuracy: 85,
    //   home_saves: 3,
    //   away_saves: 5,
    //   home_free_kicks: 8,
    //   away_free_kicks: 6,
    // }
    const resp = await http.post(
      '/live/room/get_world_cup_match_stats',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.stats || {}
  }
)
export const get_world_cup_match_lineup = createAsyncThunk(
  'worldCup/get_world_cup_match_lineup',
  async (params: any, store: any) => {
    // return getMockLineup()
    const resp = await http.post(
      '/live/room/get_world_cup_match_lineup',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data?.lineup || {}
  }
)
export const get_room_role = createAsyncThunk(
  'worldCup/get_room_role',
  async (params: any, store: any) => {
    const {h_web_room_id, h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/room/get_room_role',
      {
        room_id: h_web_room_id,
        mid: h_m,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    const role = resp?.data?.data?.role || 0
    if (role === 0) {
      return 2
    }
    if (role === 1) {
      return 0
    }
    return 1
  }
)

export interface InitialStateType {
  cupList: Array<any>
  matchEvents: Array<any>
  matchDetail: any
  matchStats: any
  matchLineUps: any
  base: {
    role: number
  }
}

const initialState: InitialStateType = {
  cupList: [],
  matchEvents: [],
  matchDetail: {},
  matchStats: {},
  matchLineUps: {},
  base: {
    role: 0,
  },
}

export const WorldCupSlice = createSlice({
  name: 'worldCup',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_world_cup_match_list.fulfilled, (state, action) => {
      Object.assign(state, {cupList: action.payload})
    })
    builder.addCase(get_world_cup_match_events.fulfilled, (state, action) => {
      Object.assign(state, {matchEvents: action.payload})
    })
    builder.addCase(get_world_cup_match_detail.fulfilled, (state, action) => {
      Object.assign(state.matchDetail, action.payload)
    })
    builder.addCase(get_world_cup_match_stats.fulfilled, (state, action) => {
      Object.assign(state.matchStats, action.payload)
    })
    builder.addCase(get_world_cup_match_lineup.fulfilled, (state, action) => {
      Object.assign(state.matchLineUps, action.payload)
    })
    builder.addCase(get_room_role.fulfilled, (state, action) => {
      Object.assign(state.base, {role: action.payload})
    })
  },
})
export default WorldCupSlice.reducer
export const WorldCupActions = WorldCupSlice.actions

export const useWorldCupState = () => {
  const data = useSelector((state) => {
    return state.worldCup
  })
  return data
}
